import axios from "axios";
import React, { createContext, useContext, useState, useEffect } from "react";

// import { io } from "socket.io-client";
// const socket = io("https://api.mirai.healthcare/");

const ProductContext = createContext();

function AppContext({ children }) {
  const [session, setSessionata] = useState([]);
  const [Session, setSessionData2] = useState([]);


  
  const [allClass, setAddClass] = useState([]);
  const authtoken = localStorage.getItem("token");
  const [userData, setuserData] = useState(null);
  const [userId, setuserId] = useState(null);
  const [StaffData, setStaffData] = useState(null);
  const [error, setError] = useState(null);
  const [Class, setClass] = useState(null);
  const [Section, setSection] = useState(null);
  const [classSectionId, setClassSectionId] = useState(null);
  const [userType, setUserType] = useState(null); 
  const [ClassSection, setClassSection] = useState(null);
  const [classSections22, setClassSectionsNew] = useState([]);

  const [Dashboarddata, setDashboarddata] = useState(null);
  const [HouseData, setHouseData] = useState(null);


  const fetchUserData = async () => {
    if (!authtoken) {
      console.log("No token found");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/register/dashboard",
        {
          headers: {
            "x-auth": `${authtoken}`,
          },
        }
      );

      console.log("API response:", response.data);

      if (response.data.success) {
        setDashboarddata(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchHouseData = async () => {
      try {
        const response = await fetch(`https://api.mirai.healthcare/api/masters/house`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-auth": `${authtoken}`,
          },
        });
  
        if (response.ok) {
          const data = await response.json();
          setHouseData(data);
        } else {
          console.error("Failed to fetch house data");
        }
      } catch (error) {
        console.error("Error fetching house data:", error);
      }
    };

  const [getRegistration, setGetRegistration] = useState(null);
  const [CastCategory, setCastCategory] = useState([]);
  

  const fetchUserProfileData = () => {
    fetch(`https://api.mirai.healthcare/api/user/currentuser`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "x-auth": `${authtoken}`,
      },
    })
      // .then((response) => response.json())
      .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
      .then((data) => {
        setuserData(data);
        setUserType(data?.currentUser?.usertype); 
        const fullName = `${data?.currentUser?.fname} ${data?.currentUser?.lname}`;
        const email = data?.currentUser?.email;
        localStorage.setItem("UserName1", data?.currentUser?.username);
        localStorage.setItem("FullName", fullName);
        localStorage.setItem("Email", email);
      })
      .catch((error) => console.error("Fetch error:", error));
  };

  

  // useEffect(() => {
  // if(authtoken){
  // fetchUserProfileData();
  // }, [authtoken]);

  useEffect(() => {
  if (!authtoken) return;
    fetchUserProfileData();
}, [authtoken]);


  console.log(userData, "userData Auth")

  const fetchSectionData = () => {
  fetch(`https://api.mirai.healthcare/api/masters/citystate`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
      setSection(data);
    })
    .catch((error) => {
      console.error("Error fetching Section data:", error);
        setError("Error fetching subject data");
    });
};

const fetchGetStaffDetailsData = () => {
  fetch(`https://api.mirai.healthcare/api/staff-Registration/getstaffdetails`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
      setStaffData(data);
    })
    .catch((error) => {
        console.error("Error fetching staff data:", error);
        setError("Error fetching staff data");
    });
};
 


  const [casteData, setCasteData] = useState([]);
  const [allConplaint, setConplaint] = useState([]);

  const fetchComplaintData = async () => {
  try {
    const response = await fetch("https://api.mirai.healthcare/api/masters/complaint", {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        'x-auth' : `${authtoken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const formattedSessions = data?.map((sessionItem) => ({
      value: sessionItem.id,
      label: sessionItem.complaincategory,
    }));

    setConplaint(formattedSessions || []);
  } catch (error) {
    console.error("Fetch error Complaint:", error);
  } finally {
    setLoading(false);
  }
};
 

  const fetchCasteCategory = () => {
  fetch(`https://api.mirai.healthcare/api/masters/castcategory`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
    const formattedCaste = data?.data?.map((casteitem) => ({
      value: casteitem?.id,
      label: casteitem?.category,
    }));
    setCastCategory(data);
       if (data?.success && Array.isArray(data?.data)) {
          setCasteData(data?.data);
        } else {
          console.error("Unexpected response format:", data);
          setCasteData([]);
        }
    })
    .catch((error) => {
        console.error("Error fetching Caste category data:", error);
        setError("Error fetching Caste category data");
    });
};

  


  const [cityData, setCityData] = useState([]);

  const fetchCityStateData = () => {
  fetch(`https://api.mirai.healthcare/api/masters/citystate`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
        if (data?.success && Array.isArray(data?.data)) {
          setCityData(data.data);
        } else {
          console.error("Unexpected response format:", data);
          setCityData([]);
        }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      setCityData([]);
    });
};

  


  const [Religion, setReligionData] = useState([]);

 
  const fetchReligionalData = () => {
  fetch(`https://api.mirai.healthcare/api/masters/religion`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
        setReligionData(data);
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};


 const fetchStudentData = () => {
  fetch(`https://api.mirai.healthcare/api/masters/session`, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return; // Stop here
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json(); // Parse JSON if okay
    })
    .then((data) => {
      if (!data) return;

      const formattedSessions = data?.data?.map((sessionItem) => ({
        value: sessionItem.id,
        label: sessionItem.Name,
      }));
      setSessionata(formattedSessions || []);
      setSessionData2(data)

      
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};

  console.log(session, "session 1500 Auth");



  // useEffect(() => {
  //   const fetchClassData = async () => {
  //     try {
  //       const response = await fetch(`https://api.mirai.healthcare/api/masters/classes`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "x-auth": `${authtoken}`,
  //         },
  //       });

  //       if (response.ok) {
  //         const data = await response.json();
  //         setClass(data); // Update fetched subject
  //         console.log("Class fetched successfully:", data);
  //       } else {
  //         console.error("Failed to fetch subject data");
  //         setError("Failed to fetch subject data");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching subject data:", error);
  //       setError("Error fetching subject data");
  //     }
  //   };

  //   fetchClassData();
  // }, [authtoken]);
    const [loading, setLoading] = useState(false);


  const fetchAddClassData = async () => {
  try {
    console.log("Auth token:", authtoken); // ✅ Debug check

    const response = await fetch("https://api.mirai.healthcare/api/masters/classes", {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "x-auth": authtoken,
      },
    });

    if (response.status === 401) {
      console.log("Unauthorized - navigating to login");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Class Data:", data);

    const formattedSessions = data?.data?.map((classItem) => ({
      value: classItem?.id,
      label: classItem?.Classes,
      agegroup: classItem?.Age_Group,
    }));

    setAddClass(formattedSessions || []);
    setClass(formattedSessions || []);
  } catch (error) {
    console.error("Fetch error New:", error);
  } finally {
    setLoading(false);
  }
};

  const [getenquiry, setGetEnquiry] = useState(null);

  // const fetchMyEnquiryData = () => {
  //   fetch(`https://api.mirai.healthcare/api/enquiry/user-enquiry`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       "x-auth": `${authtoken}`,
  //     },
  //   })
  //   .then((response) => {
  //     if (response.status === 401) {
  //       console.log("Unauthorized - navigating to login");
  //       if (window.location.pathname !== "/login") {
  //         window.location.href = "/login";
  //       }
  //       return;
  //     }

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     return response.json();
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //                       setGetEnquiry(response?.data);
  //       return response.json();

  //     })
  //     .catch((error) => {
  //       console.error("Fetch error:", error);
  //     });
  // };

  // const fetchMyReegistrationData = () => {
  //   fetch(`https://api.mirai.healthcare/api/register/user-registration`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       "x-auth": `${authtoken}`,
  //     },
      
  //   })
  //     .then((response) => {
        
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       // Populate the form data
  //       setGetRegistration(data);
  //       setuserId(data?.data?.id);
  //       localStorage.setItem("ClassId", data?.data?.select_class);
  //     })
  //     .catch((error) => {
  //       console.error("Fetch error:", error);
  //     });
  // };
  
    const [Automationdata, setAutomationdata] = useState(null);
      const [ExamType, setExamType] = useState(null);

  
  const fetchSchoolAutomationData = async () => {
     
  
      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/head/school-rule/school-automation",
          {
            headers: {
              // "x-auth": `${authtoken}`,
              accept: "application/json",
            },
          }
        );
        if (response) {
          setAutomationdata(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchExamTypeData = async () => {
      try {
        const response = await fetch(`https://api.mirai.healthcare/api/exam-type`, {
          method: "GET",
          headers: {
            Accept: "application/json, text/plain",
            "Content-Type": "application/json;charset=UTF-8",
            "x-auth": `${authtoken}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setExamType(data);
          console.log("Exam Type fetched successfully:", data);
        } else {
          console.error("Failed to fetch Exam Type data");
          setError("Failed to fetch Exam Type data");
        }
      } catch (error) {
        console.error("Error fetching Exam Type data:", error);
        setError("Error fetching Exam Type data");
      }
    };


    useEffect(() => {
    fetchSchoolAutomationData();
    fetchExamTypeData();
  }, []);
  
  const fetchMyEnquiryData = () => {
    fetch(`https://api.mirai.healthcare/api/enquiry/user-enquiry`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth": `${authtoken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Populate the form data
        setGetEnquiry(data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };
 const fetchMyReegistrationData = () => {
  const token = localStorage.getItem("token"); // or your auth token source

  if (!token) {
    console.log("No token found. Skipping fetch.");
    return;
  }

  fetch(`https://api.mirai.healthcare/api/register/user-registration`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth": `${token}`,
    },
  })

   .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      if (!data) return;

      setGetRegistration(data);
      setuserId(data?.data?.id);
      localStorage.setItem("ClassId", data?.data?.select_class);
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};


  const [GetstudentData, setGetStudentData] = useState(null);
  const [clsSecId, setClsSecId] = useState(null);

   useEffect(() => {
          if (!userId) return;
  
          const fetchStudentId = async () => {
              try {
                  const response = await fetch(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
                      headers: { "x-auth": `${authtoken}` }
                  });
  
                  const data = await response.json();
                  if (data.success && data.message.length > 0) {
                      const studentData = data.message[0];
                      setGetStudentData(studentData);
                      setClsSecId(studentData.class_section_id);
                  }
              } catch (error) {
                  console.error("Error fetching student data:", error);
              }
          };
  
          fetchStudentId();
      }, [userId, authtoken]);

      



  const classIdNew = getenquiry?.data[0]?.class;

  const [getNotification, setGetNotification] = useState([]);

  const fetchNotificationData = () => {
    fetch(`https://api.mirai.healthcare/notification`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth": `${authtoken}`,
      },
    })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
      .then((data) => {
        // Populate the form data
        setGetNotification(data?.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  const [getMenuList, setGetMenuList] = useState([]);

  // const fetchMenuListData = () => {
  //   fetch(`https://api.mirai.healthcare/api/user/menu`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       "x-auth": `${authtoken}`,
  //     },
  //   })
  //   .then((response) => {
  //     if (response.status === 401) {
  //       console.log("Unauthorized - navigating to login");
  //       if (window.location.pathname !== "/login") {
  //         window.location.href = "/login";
  //       }
  //       return;
  //     }

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     return response.json();
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       // Populate the form data
  //       setGetMenuList(data?.message?.menus);
  //     })
  //     .catch((error) => {
  //       console.error("Fetch error:", error);
  //     });
  // };

  const fetchMenuListData = () => {
  fetch(`https://api.mirai.healthcare/api/user/menu/web`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth": `${authtoken}`,
    },
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized - navigating to login");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    })
    .then((data) => {
      // ✅ Print full response
      console.log("Full API response:", data);

      // ✅ Print only menu list
      console.log("Menu list:", data?.message?.menus);

      // ✅ Store menu in state
      setGetMenuList(data?.message?.menus);
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};

 const fetchClassSectionData = async () => {
      try {
        const response = await fetch(`https://api.mirai.healthcare/api/masters/class_section`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Content-Type": "application/json",
            "x-auth": `${authtoken}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setClassSection(data);
          setClassSectionsNew(data?.data || []);
          console.log("class_section fetched successfully:", data);
        } else {
          console.error("Failed to fetch class_section data");
          setError("Failed to fetch class_section data");
        }
      } catch (error) {
        console.error("Error fetching class_section data:", error);
        setError("Error fetching class_section data");
      }
    };


  useEffect(() => {
  if (!authtoken) return;
    fetchStudentData();
    fetchReligionalData();
    fetchSectionData();
    fetchCasteCategory(); 
    fetchGetStaffDetailsData();
    fetchCityStateData();
    fetchAddClassData();
    fetchMyEnquiryData();
    fetchMyReegistrationData();
    fetchNotificationData();
    fetchMenuListData();
    fetchCasteCategory();
    fetchUserData();
    fetchComplaintData();
    fetchClassSectionData();
    fetchHouseData();
    
  }, [authtoken]);

  // useEffect(() => {
  //   if (authtoken && !userData) {
  //     fetchUserProfileData();
  //   }
  // }, []);

console.log(getenquiry, "getenquiry1500015")
  const dataNew = getenquiry?.data[0];

  return (
    <ProductContext.Provider
      value={{
        session: session || [],
        allClass: allClass || [],
        getenquiry,
        setGetEnquiry,
        fetchMyEnquiryData,
        dataNew,
        classIdNew,
        getRegistration,
        setGetRegistration,
        fetchMyReegistrationData,
        userData,
        userId,
        Class,
        StaffData,
        setuserData,
        casteData,
        cityData,
        getNotification,
        setGetNotification,
        fetchNotificationData,
        fetchCasteCategory,
        CastCategory,
        fetchUserProfileData,
        Section: Section || [],
        fullName: `${userData?.currentUser?.fname} ${userData?.currentUser?.lname}`,
        email: userData?.currentUser?.email,
        Religion,
        classSectionId,
        setClassSectionId,
        ExamType,
        userType, 
        GetstudentData,
        getMenuList,
        clsSecId,
        Session,
        Class,
        Automationdata,
        fetchReligionalData,
        Dashboarddata,
        allConplaint: allConplaint || [],
        ClassSection,
        HouseData,
        fetchHouseData,
        classSections22
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}

export { ProductContext, AppContext };
